import React, { useEffect, useState } from 'react';
import {
  Button,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableFooter,
  TableHead,
  TablePagination,
  TableRow,
} from '@material-ui/core';
import { useHistory } from 'react-router-dom';
import ArrowRightIcon from '@mui/icons-material/ArrowRight';
import moment from 'moment';
import {
  HOUSEKEEPING_COUNTBOX_LIST,
  HOUSEKEEPING_FILTER,
  HOUSEKEEPING_STATUS,
  HOUSEKEEPING_TYPES,
  HOUSEKEEPING_VIEW,
} from '../../../../constants/DashboardConst';
import SearchBar from '../../../../shared/search-bar/Search-Bar';
import LinearProgressBar from '../../../../shared/progress-bar/Progress';
import { getOrderCountsList, generatedElapsedTime } from '../../../../utils/dashboardUtils';
import TablePaginationActions from '../../../../shared/table-pagination/TablePaginationActions';
import CustomCountBox from '../../../../shared/custom-count-box/Custom-Count-Box';
import './Dashboard-Housekeeping.scss';

const DashboardHousekeepingList = (props) => {
  const {
    onViewToggle,
    allOrdersList,
    page,
    rowsPerPage,
    onsetRowsPerPage,
    onsetPage,
    currentFilterFromLocation,
  } = props;
  const history = useHistory();
  const [filterDataList, setFilterDataList] = useState([]);
  const [housekeepingOrders, setHousekeepingOrders] = useState([]);
  const [orderCountList, setOrderCountList] = useState([]);
  const [loading, setLoading] = useState(true);
  const [tempSearchText, setTempSearchText] = useState('');
  const [filteredBaseList, setFilteredBaseList] = useState([]);

  const onViewDetails = (order) => {
    onViewToggle(HOUSEKEEPING_VIEW, true, order);
  };

  useEffect(() => {
    setOrderCountList(getOrderCountsList(HOUSEKEEPING_COUNTBOX_LIST, allOrdersList));
    setHousekeepingOrders(sortList(allOrdersList));
    setFilteredBaseList(sortList(allOrdersList));
    setLoading(false);
    setTempSearchText('');
  }, [allOrdersList]);

  useEffect(() => {
    const updatedFilter = [...HOUSEKEEPING_FILTER];
    updatedFilter[1]?.subMenu?.forEach((elm) => {
      elm.selected = false;
      return elm;
    });
    updatedFilter[2]?.subMenu?.forEach((elm) => {
      elm.selected = false;
      return elm;
    });
    setFilterDataList(updatedFilter);
  }, []);

  useEffect(() => {
    if (currentFilterFromLocation) {
      let subFilter = [...HOUSEKEEPING_STATUS];
      if (currentFilterFromLocation === 'ALL') {
        subFilter = HOUSEKEEPING_STATUS.map((x) => {
          return { ...x, selected: false };
        });
      } else {
        subFilter = HOUSEKEEPING_STATUS.map((x) => {
          return { ...x, selected: x.id === currentFilterFromLocation };
        });
      }
      HOUSEKEEPING_FILTER[1].subMenu = subFilter;
      setFilterDataList(HOUSEKEEPING_FILTER);
      const filteredItems = allOrdersList.filter((item) => {
        return item?.status === currentFilterFromLocation;
      });
      onsetPage(0);
      setHousekeepingOrders(
        sortList(currentFilterFromLocation !== 'ALL' ? filteredItems : allOrdersList),
      );
    }
  }, [currentFilterFromLocation, allOrdersList]);

  const setSearchText = (searchText) => {
    // Temporarily closed
    // let tempData = HOUSEKEEPING_FILTER[1]?.subMenu?.map((x) => {
    //   return { ...x, selected: false };
    // });
    // setFilterDataList(tempData);
    setTempSearchText(searchText);
    onsetPage(0);
    if (!searchText) {
      setHousekeepingOrders(filteredBaseList);
      return;
    }
    const filteredRows = filteredBaseList?.filter((item) => {
      return (
        item.guestName?.toLowerCase()?.includes(searchText?.toLowerCase()) ||
        item.serviceName?.toLowerCase()?.includes(searchText?.toLowerCase()) ||
        item.id?.includes(searchText) ||
        item.roomNo?.includes(searchText)
      );
    });
    setHousekeepingOrders(sortList(filteredRows));
  };

  const filteredRecords = (filters, field) => {
    if (field === 'all') {
      setFilteredBaseList(sortList(allOrdersList));
      setHousekeepingOrders(sortList(allOrdersList));
      HOUSEKEEPING_FILTER[1].subMenu = HOUSEKEEPING_STATUS;
      HOUSEKEEPING_FILTER[2].subMenu = HOUSEKEEPING_TYPES;
      setFilterDataList(HOUSEKEEPING_FILTER);
    } else {
      const filterIdWithFields = filterDataList
        .filter((initialFilter) => initialFilter.subMenu.length > 0)
        .map((filterItem) => {
          const subMenuFiltersId = filterItem.subMenu
            .filter((fItem) => fItem.selected === true)
            .map((fItemId) => fItemId.id);
          if (subMenuFiltersId.length > 0) {
            return {
              id: subMenuFiltersId,
              field: filterItem.field,
            };
          } else return null;
        })
        .filter((item) => item !== null);

      const filteredItems = allOrdersList.filter((item) => {
        const doesFilterSatisfy = filterIdWithFields.map((filter) =>
          filter.id.includes(item[filter.field]),
        );
        return !doesFilterSatisfy.includes(false);
      });
      onsetPage(0);
      setFilteredBaseList(sortList(filteredItems));
      setHousekeepingOrders(sortList(filteredItems));
    }
  };

  const handleChangePage = (event, newPage) => {
    onsetPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    onsetRowsPerPage(parseInt(event.target.value, 10));
    onsetPage(0);
  };

  const getTimeDifference = (time, startTime) => {
    const startDate = startTime ? moment.unix(startTime) : moment();
    const endDate = moment.unix(time);
    const timeDifference = generatedElapsedTime(startDate, endDate);
    return timeDifference;
  };

  const sortList = (data) => {
    let tempData = [...data].sort(function (a, b) {
      return b.createdAt - a.createdAt;
    });
    return tempData;
  };

  return (
    <div className='container px-2 py-2 dashboard-housekeeping mw-100'>
      <div className='col'>
        <div className='d-flex justify-content-end'>
          <Button
            variant='outlined'
            color='secondary'
            size='large'
            endIcon={<ArrowRightIcon />}
            onClick={() => history.push('/service-request')}
          >
            View Services
          </Button>
        </div>
      </div>
      {orderCountList?.length > 0 && (
        <div>
          <div className='py-2 d-flex flex-wrap gap-3'>
            {orderCountList?.map((currentCount, countNdx) => (
              <CustomCountBox count={currentCount} key={countNdx} className={'col'} />
            ))}
          </div>
        </div>
      )}
      <div className='dashboard-housekeeping-list'>
        <div className='card shadow'>
          <div className='py-2 group-list-container'>
            <SearchBar
              displayAddOrEdit='hide'
              setSearchText={setSearchText}
              filterList={filterDataList}
              setFilterDataList={setFilterDataList}
              filteredRecoard={filteredRecords}
              searchText={tempSearchText}
              setSearch={setTempSearchText}
              actionMenuItems={[]}
            />
            <div className='row py-2 px-3 d-flex'>
              {loading ? (
                <div className='pt-2 col-md-12'>
                  <LinearProgressBar />
                </div>
              ) : (
                housekeepingOrders && (
                  <TableContainer>
                    <Table className='list-table' aria-label='simple table'>
                      <TableHead>
                        <TableRow className='border-white pointer'>
                          <TableCell className='w-15'>Time Elapsed</TableCell>
                          <TableCell className='w-15' align='center'>
                            Room No
                          </TableCell>
                          <TableCell className='w-15' align='center'>
                            Service name
                          </TableCell>
                          <TableCell className='w-20' align='center'>
                            Guest name
                          </TableCell>
                          <TableCell className='w-10' align='center'>
                            Type
                          </TableCell>
                          <TableCell className='w-15' align='center'>
                            Status
                          </TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {(rowsPerPage > 0
                          ? housekeepingOrders.slice(
                              page * rowsPerPage,
                              page * rowsPerPage + rowsPerPage,
                            )
                          : housekeepingOrders
                        ).map((item, i) => (
                          <TableRow
                            key={i}
                            className='border-white pointer'
                            onClick={(e) => {
                              onViewDetails(item, e);
                            }}
                          >
                            <TableCell align='left'>{getTimeDifference(item?.createdAt)}</TableCell>
                            <TableCell align='center'>{item.roomNo}</TableCell>
                            <TableCell align='center'>{item.serviceName}</TableCell>
                            <TableCell align='center'>{item.guestName}</TableCell>
                            <TableCell align='center'>{item.requestType}</TableCell>

                            <TableCell align='center'>
                              <div className='d-flex align-content-center px-2'>
                                <div
                                  className={
                                    item?.statusClass +
                                    ' pill d-flex justify-content-center align-items-center py-2 w-90'
                                  }
                                >
                                  <span className='ms-1'>{item.orderStatus ?? 'NA'}</span>
                                </div>
                              </div>
                            </TableCell>
                          </TableRow>
                        ))}
                      </TableBody>
                      <TableFooter>
                        <TableRow className='paginator'>
                          <TablePagination
                            rowsPerPageOptions={[5, 10, 25, { label: 'All', value: -1 }]}
                            count={housekeepingOrders.length}
                            rowsPerPage={rowsPerPage}
                            page={page}
                            SelectProps={{
                              inputProps: { 'aria-label': 'rows per page' },
                              native: true,
                            }}
                            onPageChange={handleChangePage}
                            onRowsPerPageChange={handleChangeRowsPerPage}
                            ActionsComponent={TablePaginationActions}
                          />
                        </TableRow>
                      </TableFooter>
                    </Table>
                  </TableContainer>
                )
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DashboardHousekeepingList;
